defineCustomVueElement('csb-compatible-chains', {
    name: 'Compatbile Chains',
    template: `<div class="page-width" v-if="chains.length > 0">
    <h3>Compatible Chains</h3>
    <slick v-bind="sliderSettings">
      <div class="slide" v-for="item in chains">
        <section :id="'CompatProduct-template--compat-' + item.variant_id" :data-section="'template--compat-' + item.variant_id">
          <div class="card-wrapper product-card-wrapper underline-links-hover">
            <div class="card card--standard card--text" style="--ratio-percent: 100%;">
                <a :href="item.uri"><img :src="item.image" style="max-width: 100%" /></a>
                <div class="card__inner">
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                        <a :href="item.uri" v-html="item.title" class="full-unstyled-link"></a>
                    </h3>
                    <div class="card-information"><span class="caption-large light"></span>
                      <div class="
                          price ">
                        <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span class="price-item price-item--regular" v-html="price(item.price)">
                              </span></div>
                          <div class="price__sale">
                              <span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span>
                                <s class="price-item price-item--regular">
                                </s>
                              </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
                            <span class="price-item price-item--sale price-item--last" v-html="price(item.price)">
                            </span>
                          </div>
                          <small class="unit-price caption hidden">
                            <span class="visually-hidden">Unit price</span>
                            <span class="price-item price-item--last">
                              <span></span>
                              <span aria-hidden="true">/</span>
                              <span class="visually-hidden">&nbsp;per&nbsp;</span>
                              <span>
                              </span>
                            </span>
                          </small>
                        </div>
                      </div>                    
                    </div>
                    </div>
                  </div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
          </div>    
          <!-- button type="button" name="add" class="button button--full-width button--secondary" @click="addToCart(item.variant_id)">{{ addToCartText }}</button -->
  
          <product-form class="product-form" data-hide-errors="false" :data-section-id="'template--compat-' + item.variant_id" defer-hydration>
            <div class="product-form__error-message-wrapper" role="alert" hidden>
              <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2" />
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7" />
                <path
                  d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z"
                  fill="white" />
                <path
                  d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z"
                  fill="white" stroke="#EB001B" stroke-width="0.7" />
              </svg>
              <span class="product-form__error-message"></span>
            </div>
            <form method="post" action="/cart/add" :id="'product-form-template--compat-' + item.variant_id" accept-charset="UTF-8"
              class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden"
                name="form_type" value="product" /><input type="hidden" name="utf8" value="✓" /><input type="hidden" name="id"
                :value="item.variant_id" class="product-variant-id">
              <div class="product-form__buttons"><button :id="'ProductSubmitButton-template--compat-' + item.variant_id"
                  type="submit" name="add" class="product-form__submit button button--full-width button--secondary">
                  <span>{{ addToCartText }}</span>
                  <div class="loading__spinner hidden">
                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
                <div data-shopify="payment-button" class="shopify-payment-button"> <shopify-accelerated-checkout
                    recommended="null" fallback="{&quot;name&quot;:&quot;buy_it_now&quot;,&quot;wallet_params&quot;:{}}"
                    access-token="014d4b8af4f9f58c8939f330e2a795a3" buyer-country="GB" buyer-locale="en" buyer-currency="GBP"
                    variant-params="[{&quot;id&quot;:49844189102400,&quot;requiresShipping&quot;:true}]" shop-id="87810736448">
                    <div class="shopify-payment-button__button" role="button" disabled aria-hidden="true"
                      style="background-color: transparent; border: none">
                      <div class="shopify-payment-button__skeleton">&nbsp;</div>
                    </div>
                  </shopify-accelerated-checkout> <small id="shopify-buyer-consent" class="hidden" aria-hidden="true"> This item
                    is a recurring or deferred purchase. By continuing, I agree to the <span
                      id="shopify-subscription-policy-button">cancellation policy</span> and authorize you to charge my payment
                    method at the prices, frequency and dates listed on this page until my order is fulfilled or I cancel, if
                    permitted. </small> </div>
              </div><input type="hidden" name="product-id" :value="item.variant_id" /><input type="hidden" name="section-id"
                :value="'template--compat-' + item.variant_id" />
            </form>
          </product-form>
        </section>
      </div>
    </slick>
  </div>`,
    props: {
        addToCartText: { default: 'Add Me!' },
        chainSpec: { default: '[]' }
    },
    components: { slick: Vue3SlickCarousel.VSlickCarousel },
    data() {
        return {
        chains: [],
        csbStore: useCsbStore(),
        sliderSettings: {
            "dots": true,
            "infinite": false,
            "groupsToScroll": 1,
            "groupsToShow": 1,
            "slidesPerGroup": 1,
            "swipe": true,
            "ignorePrefersReducedMotion": true,
            "responsive": [
            {
                "breakpoint": 480,
                "settings": {
                "groupsToScroll": 2,
                "groupsToShow": 2
                }
            },
            {
                "breakpoint": 680,
                "settings": {
                "groupsToScroll": 3,
                "groupsToShow": 3
                }
            },
            {
                "breakpoint": 1080,
                "settings": {
                "groupsToScroll": 4,
                "groupsToShow": 4
                }
            },
            {
                "breakpoint": 1200,
                "settings": {
                "groupsToScroll": 5,
                "groupsToShow": 5
                }
            },
            {
                "breakpoint": 8000,
                "settings": {
                "groupsToScroll": 6,
                "groupsToShow": 6
                }
            }
            ]
        }
        }
    },
    methods: {
        price(priceData) {
        return '&pound;' + parseFloat(priceData.amount).toFixed(2) + ' GBP'
        },
        async addToCart(id) {
        await this.csbStore.addItem(id.replace('gid://shopify/ProductVariant/', ''), 1)
        }
    },
    async mounted() {
        this.chains = await this.csbStore.getCompatibleChains(JSON.parse(this.chainSpec))
    },
}, { plugins: [ piniaStore ] })
